/**
 * All channels used by angular's WebWorker components are listed here.
 * You should not use these channels in your application code.
 */
export const RENDERER_CHANNEL = "ng-Renderer";
export const EVENT_CHANNEL = "ng-Events";
export const ROUTER_CHANNEL = "ng-Router";

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
